import React, {useRef} from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {Box, InputBase, IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface Props {
  searchValue: string;
  setSearchValue: (value: string) => void;
}
export default function SearchAddressInput({searchValue, setSearchValue}: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const {t} = useTranslation();
  const handleClear = () => {
    setSearchValue('');
    inputRef.current?.focus();
  };

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  return (
    <Box sx={{pt: 2}}>
      <Box sx={styles.wrapper} onClick={handleFocus}>
        <LocationOnIcon sx={styles.icon} />

        <InputBase
          inputRef={inputRef}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder={t('label.searchAddress')}
          sx={styles.input}
          inputProps={{'aria-label': 'search address'}}
        />

        {searchValue && (
          <IconButton size="small" sx={styles.clearButton} onClick={handleClear}>
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

const styles = {
  container: {
    margin: '0px 0'
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #e0e0e0',
    borderRadius: '24px',
    padding: '4px 12px',
    maxWidth: '600px',
    backgroundColor: '#f8f8f8',
    cursor: 'text'
  },
  icon: {
    color: 'crimson',
    marginRight: '4px'
  },
  input: {
    flex: 1,
    fontSize: {
      xs: '12px',
      md: '16px'
    },
    color: '#333'
  },
  clearButton: {
    color: '#b0b0b0'
  }
};
